import { useMemo } from "react";
import { pick } from "lodash";

import type { UnitLevelCoverages } from "@covertree/new-business-graphql";
import { customizablePackageCoverageKeys } from "@covertree/new-business-mappings";

import {
  selectEndorsementUnitLevelCoverages,
  useEndorsementSelector,
} from "@redux/slices/endorsement";

/**
 * Base coverages (Cov A–F, deductibles, water damage) of the endorsed unit
 */
export const useBaseCoverages = () => {
  const unitLevelCoverages = useEndorsementSelector(
    selectEndorsementUnitLevelCoverages
  );

  return useMemo(
    () =>
      unitLevelCoverages &&
      (pick(
        unitLevelCoverages,
        customizablePackageCoverageKeys
      ) as unknown as UnitLevelCoverages),
    [unitLevelCoverages]
  );
};
